module.exports = __webpack_public_path__ + "img/faq-md.b4f9a7e0.svg";